// Global
import React from 'react';
import styles from './FeatureDecor.module.scss';
import clsx from 'clsx';

export const FeatureDecor = () => {
  return (
    <div className={clsx(styles.decor, styles.hideDecorInTablet)}>
      <svg
        className={clsx(styles.top, styles.overrideFillColor)}
        xmlns="http://www.w3.org/2000/svg"
        width="411"
        height="345"
        viewBox="0 0 411 345"
        fill="none"
      >
        <path d="M0 0L411 0L0 345L0 0Z" fill="currentColor" />
      </svg>

      <svg
        className={clsx(styles.bottom, styles.overrideFillColor)}
        xmlns="http://www.w3.org/2000/svg"
        width="411"
        height="345"
        viewBox="0 0 411 345"
        fill="none"
      >
        <path d="M411 345L0 345L411 0L411 345Z" fill="currentColor" />
      </svg>
    </div>
  );
};
